"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsGrid = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const views_1 = require("./views");
const EmptyInfo_1 = require("../EmptyInfo");
const hooks_1 = require("../lib/hooks");
const LoadMore = (0, app_1.styled)(ui_1.Button) `
  ${(theme) => theme.flexCenter}
  margin: 0 auto;
  margin-top: ${(theme) => theme.spacing.small};
`;
function ProductsGrid({ className, categoryMapper = (category) => [category], }) {
    var _a, _b;
    const { t } = (0, app_1.useTranslation)();
    const [fetchedAll, setFetchedAll] = (0, react_1.useState)(false);
    const { category, params, ready } = (0, hooks_1.useSearchMeta)();
    const [fetchingNewData, setFetchingNewData] = (0, react_1.useState)(false);
    const queryTake = 12;
    const saleFilter = category === 'sale';
    const { data: products, loading, fetchMore, error, } = (0, app_1.useQuery)('getProducts', {
        withoutArgs: 'WAIT',
        args: ready
            ? Object.assign(Object.assign(Object.assign(Object.assign({}, (params.sort
                ? { sort: { by: params.sort, order: (_a = params.sortOrder) !== null && _a !== void 0 ? _a : 'desc' } }
                : { sort: { by: 'createdAt', order: 'desc' } })), { take: queryTake, title: (_b = params.search) !== null && _b !== void 0 ? _b : '' }), (saleFilter && { onSale: saleFilter })), (category && !saleFilter
                ? { categories: categoryMapper(category) }
                : {})) : null,
        select: {
            slug: true,
            title: true,
            images: true,
            category: {
                title: true,
            },
            price: {
                price: true,
                currency: true,
                otherPrices: true,
                regularPrice: true,
                lowestPriceBeforeSale: true,
            },
        },
    });
    const stringifiedParams = JSON.stringify(params);
    (0, react_1.useEffect)(() => {
        setFetchingNewData(true);
    }, [stringifiedParams]);
    (0, react_1.useEffect)(() => {
        if (loading) {
            setFetchedAll(false);
        }
        else {
            setFetchingNewData(false);
        }
    }, [loading]);
    (0, react_1.useEffect)(() => {
        if ((products !== null && products !== void 0 ? products : []).length % queryTake !== 0) {
            setFetchedAll(true);
        }
    }, [products]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(views_1.ProductsGridView, { products: fetchingNewData ? [] : products !== null && products !== void 0 ? products : [], loading: loading, className: className }), ((!loading && (products === null || products === void 0 ? void 0 : products.length) === 0) || error) && ((0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo.Margin, { children: (0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo, { title: t('error.noResults'), svg: svg_1.SvgInfo }) })), !loading && products && (products === null || products === void 0 ? void 0 : products.length) !== 0 && !fetchedAll && ((0, jsx_runtime_1.jsx)(LoadMore, Object.assign({ kind: "transparent", onClick: () => void fetchMore({ after: products[products.length - 1].id }) }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: t('label.loadMore') })) })))] }));
}
exports.ProductsGrid = ProductsGrid;
